import { Box, TextField, Typography, useTheme } from "@mui/material"
import { useHistory, useLocation } from "react-router-dom"
import ContiSpecificButton from "components/ContiSpecificButton"
import { useCallback, useState } from "react"
import { default as Ate_original } from "../../assets/images/Ate_Original.jpg"
import { default as Conti_original } from "../../assets/images/Continental_Original.png"
import {
  ateMappCodeQrEan,
  contiMappCode,
  contiMappCodeQrEan,
  basePath,
  isAte,
  isMobile,
  GTIN_CODE,
} from "utils/Global"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { useTranslation } from "react-i18next"
import { InfoDialog as InfoDialogType } from "./types"
import { useProduct } from "contexts/ProductContext"
import InfoDialog from "components/InfoDialog"
import Scanner from "components/Scanner"
import mappScannerFrame from "../../assets/images/mapp_scanner_frame.svg"
import mappScannerFrameATE from "../../assets/images/mapp_scanner_frame_ate.svg"
import { useAuthenticityCheckStore } from "api/services/AuthenticityCheck"
import { globalEndpoint } from "types/Global"
import { BarcodeFormat } from "react-qr-barcode-scanner"

export const convertMAMPCode = (mappCode: string, long2Short: boolean) => {
  if (long2Short) return mappCode.replace(`(01)${GTIN_CODE}(21)`, "")
  else return `(01)${GTIN_CODE}(21)${mappCode}`
}

export default function MappCodeCard() {
  const { t } = useTranslation("app")
  const theme = useTheme()
  const location = useLocation()
  const [showPlaceholder, setShowPlaceholder] = useState<boolean>(true)
  const [showInfo, setShowInfo] = useState(null)
  const { productCode, setProductCode, tempProductCode, setTempProductCode } =
    useProduct()
  const history = useHistory()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [inputValue, setInputValue] = useState(null)
  const authenticityCheckStore = useAuthenticityCheckStore()
  const lang = navigator.language.slice(0, 2)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [latitude, setLatitude] = useState(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [longitude, setLongitude] = useState(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [endpoint, setEndpoint] = useState(globalEndpoint)

  // MAPP SCAN STATE
  const [error, setError] = useState(null)
  const [show, setShow] = useState(false)
  const [scan, setScan] = useState(false)

  const mappCheck = (input) => {
    if (input.length !== 12) {
      setError(t("mappIncorrectLength"))
      return false
    } else {
      setError("")
      return true
    }
  }
  const onClickHandle = (productCodeInput?: string) => {
    const finalProductCode = productCodeInput
      ? convertMAMPCode(productCodeInput?.toUpperCase(), false)
      : tempProductCode
    if (mappCheck(productCodeInput || productCode)) {
      if (finalProductCode) {
        sessionStorage.setItem("productCode", finalProductCode)
        if (!location.pathname.includes("/authenticity")) {
          history.push("/authenticity")
        } else {
          setScan(false)
          authenticityCheckStore
            .fetchAuthenticityCheckList(
              finalProductCode,
              lang,
              latitude,
              longitude,
              endpoint
            )
            .then(() => {
              sessionStorage.removeItem("productCode")
            })
            .catch((e) => {
              console.error(e)
            })
        }
      }
    }
  }

  const handleChange = useCallback((e) => {
    const _inputValue = e.currentTarget.value.toUpperCase()
    setInputValue(_inputValue)
    if (
      (!_inputValue.includes("(21)") && !_inputValue.includes("(01)")) ||
      _inputValue.length < 13
    ) {
      setTempProductCode(`(01)${GTIN_CODE}(21)${_inputValue}`)
      setProductCode(_inputValue)
    } else {
      setProductCode(_inputValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const closeScanner = () => {
    setScan(false)
    setShow(false)
    setShowPlaceholder(true)
    setProductCode("")
    setError("")
  }

  const onUpdate = (err, result) => {
    if (!!result) {
      const text = result.getText ? result.getText() : result
      if (text.match(/(01\/)(.*)(\/21\/)(.*)/) != null) {
        let _data = ""
        if (text.includes("CONTINENTAL-AFTERMARKET.COM")) {
          _data = text.replace(
            /(HTTP:\/\/CONTINENTAL-AFTERMARKET.COM\/)(01\/)(.*)(\/21\/)(.*)/,
            `$5`
          )
        } else if (text.includes("ATE.DE")) {
          _data = text.replace(/(HTTP:\/\/ATE\.DE\/01\/)(.*)\/(.*)/, `$3`)
        }

        const _tempProductCode = convertMAMPCode(_data, false)
        setTempProductCode(_tempProductCode)
        setProductCode(_data)
        onClickHandle(_data)
        // HTTP://ATE.DE/01/04068267000184/21/5Y6VZ1989NHG
      }
    }
  }

  return (
    <>
      {/* CARD */}
      {!scan && (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            minHeight: isMobile ? "0" : "340px",
            height: "auto",
            overflow: "hidden",
            background: `url(${
              !isAte ? basePath + Conti_original : basePath + Ate_original
            }) center/cover`,
            "&:before": {
              content: "''",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              filter: "blur(5px)",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              placeItems: "center",
              textAlign: "center",
              padding: "54px 16px",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Typography
              variant={isMobile ? "h6" : "h5"}
              sx={{
                fontWeight: isAte ? 400 : 600,
                fontSize: isMobile ? "20px" : "28px",
                color: theme.tokens.color.conti_typo,
                marginBottom: isMobile ? "20px" : "16px",
              }}
            >
              {t("mappCodeCard.isMyProductOriginal")}
            </Typography>
            <Typography
              variant={"h4"}
              sx={{
                fontWeight: isAte ? 400 : 600,
                fontSize: isMobile ? "16px" : "22px",
                color: theme.tokens.color.conti_typo,
              }}
            >
              {isMobile
                ? t("mappCodeCard.scanMAPPCode")
                : t("mappCodeCard.enterMAPPCode")}
            </Typography>
            {isMobile ? (
              <Box
                sx={{
                  flex: 1,
                  margin: "16px auto",
                }}
              >
                <ContiSpecificButton
                  onClick={() => setScan(true)}
                  text={t("mappCodeCard.buttonScanMAPPCode")}
                  isForwardIcon={false}
                  width="auto"
                ></ContiSpecificButton>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: null,
                  alignItems: "center",
                }}
              >
                <TextField
                  fullWidth={true}
                  id="outlined-basic-mapp-code"
                  name="mapp-code"
                  variant="outlined"
                  placeholder={showPlaceholder ? "SYLRSL6PCH8D" : ""}
                  value={productCode || ""}
                  inputProps={{
                    min: 0,
                    style: { textAlign: "center", textTransform: "uppercase" },
                  }}
                  InputProps={{
                    style: {
                      padding: "0",
                      margin: "0",
                      borderRadius: "30px",
                      textAlign: "center",
                      fontFamily: isAte
                        ? "Etelka Light"
                        : "ContinentalStagSans-Light",
                      fontSize: "14px",
                      fontStyle: "italic",
                      letterSpacing: "3px",
                      width: "100%",
                      minWidth: "272px",
                      height: "44px",
                      backgroundColor: "#ffff",
                    },
                  }}
                  style={{}}
                  onChange={handleChange}
                  onFocus={() => setShowPlaceholder(false)}
                  onBlur={() => setShowPlaceholder(true)}
                />
                <Box sx={{ margin: "15px 20px" }}>
                  <ContiSpecificButton
                    onClick={() => onClickHandle()}
                    text={t("mappCodeCard.buttonText")}
                    isForwardIcon={true}
                    width="100px"
                  ></ContiSpecificButton>
                </Box>
              </Box>
            )}
            {error && (
              <Typography
                variant={"body2"}
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "white",
                  padding: "8px",
                  backgroundColor: "#AA182A",
                  borderRadius: "8px",
                  margin: "0 auto 16px",
                }}
              >
                {error}
              </Typography>
            )}

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                cursor: "pointer",
                color: theme.tokens.color.conti_typo,
              }}
              onClick={() => setShowInfo(InfoDialogType.MAPP)}
            >
              <InfoOutlinedIcon
                sx={{ width: "24px", height: "24px" }}
                color="inherit"
              />
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  marginLeft: "5px",
                  color: theme.tokens.color.conti_typo,
                }}
              >
                {t("mappCodeCard.infoMappCode")}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}

      <InfoDialog
        showInfo={showInfo}
        setShowInfo={setShowInfo}
        title={t("mappCodeCard.infoMappCode")}
      >
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: "300",
            lineHeight: "24px",
            marginBottom: "16px",
          }}
        >
          {t("mappCodeCard.exampleLabelText")}
        </Typography>

        <img
          src={isAte ? ateMappCodeQrEan : contiMappCodeQrEan}
          width="70%"
          height={"70%"}
          alt=""
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            padding: "10px 0px",
            maxWidth: "400px",
            marginBottom: "16px",
          }}
        ></img>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: "300",
            lineHeight: "24px",
            marginBottom: "16px",
          }}
        >
          {t("mappCodeCard.newLabelText")}
        </Typography>
        <img
          src={contiMappCode}
          width="70%"
          height={"70%"}
          alt=""
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px 0px",
            maxWidth: "400px",
            margin: "0 auto",
            marginBottom: "16px",
          }}
        ></img>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: "300",
            lineHeight: "24px",
          }}
        >
          {t("mappCodeCard.olderLabelText")}
        </Typography>
      </InfoDialog>

      {(show || scan) && (
        <Scanner
          frame={
            isAte ? basePath + mappScannerFrameATE : basePath + mappScannerFrame
          }
          formatScan={BarcodeFormat.QR_CODE}
          placeholder="SYLRSL6PCH8D"
          title={
            show
              ? t("mappCodeCard.scanMAPPCode")
              : t("mappCodeCard.scanMAPPCode")
          }
          helperText={t("infoMappCode")}
          inputLabel={t("mappCodeCard.manualEnterMAPPCode")}
          error={error}
          showPlaceholder={showPlaceholder}
          productCode={productCode}
          onClickHandle={() => onClickHandle()}
          closeScanner={closeScanner}
          handleChange={handleChange}
          onUpdate={onUpdate}
          setShowPlaceholder={setShowPlaceholder}
          setShowInfo={setShowInfo}
        />
      )}
    </>
  )
}
